import styled from 'styled-components';
import { LabelRegularM, LabelRegularBoldM } from '../../../styles/globals';

export const Description = styled(LabelRegularM)`
  margin: 0;
`;

export const CardsCont = styled.ul`
  ${({ theme }) => `
    margin: 0;
    padding: 0;
    background: ${theme.colors.neutral.primary[0]};
    border-radius: 8px;
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    list-style: none;
  `};
`;

export const Card = styled.li`
  ${({ theme }) => `
    display: flex;
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.deka};
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};

    &:last-of-type {
      border-bottom: none;
    }

    @media ${theme.layout.breakpoints.max.tablet} {
      padding: ${theme.layout.spacing.centy};
    }
  `};
`;

export const ContentCont = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
`;

export const Index = styled.h4`
  ${({ theme }) => `
    margin: 0;
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    font-family: 'Roboto';
    font-size: 80px;
    font-weight: 700;
    line-height: 1;
    color: ${theme.colors.primary[100]};

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 64px;
    }
  `};
`;

export const Title = styled(LabelRegularBoldM)`
  margin: 0;
`;
